import { getGlobalConfig } from '@core/globalConfig';
import { isTruthy } from '@core/helpers/boolean';
import { logInfo } from '@core/logging';
function createStoryblock(url, channel) {
    const fwStoryblock = document.createElement('fw-storyblock');
    fwStoryblock.setAttribute('channel', channel);
    fwStoryblock.setAttribute('mode', 'pinned');
    fwStoryblock.setAttribute('cohort_url', url);
    fwStoryblock.setAttribute('player_placement', 'bottom-left');
    fwStoryblock.setAttribute('autoplay', 'true');
    fwStoryblock.setAttribute('auto_embed_widget', 'true');
    document.body.appendChild(fwStoryblock);
}
/**
 * Attaches URL discovery functionality when enabled via global config
 */
export function setup() {
    const globalConfig = getGlobalConfig();
    if (isTruthy(globalConfig.url_discovery)) {
        logInfo('FW: URL Discovery feature is enabled');
        logInfo(`FW: Current URL: ${window.location.href}`);
        logInfo('FW: Channel:', globalConfig.channel);
        const channel = globalConfig.channel;
        const url = window.location.href;
        createStoryblock(url, channel);
    }
}
